module.exports = __webpack_public_path__ + "static/img/stay-option-icon-breakfast.203920be.svg";